import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  div {
    width: 80%;
    padding: 0 137px;
  }

  section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  div[id='slide'] {
    max-width: 1080px;
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 20px 137px;
    align-items: center;
    justify-content: center;
  }

  img {
    height: 300px;
    padding: 0 37px;
  }

  strong {
    font-size: 20px;
  }
`